import React from "react";
import useTranslation from "next-translate/useTranslation";
import { errorCodes } from "@chesshotel/constants";
import styles from "../styles/RegisterError.module.css";

export default function RegisterError({
  errorCode,
  id,
}: {
  errorCode: string | null | undefined;
  id?: string;
}) {
  const { t } = useTranslation("common");
  const { t: authT } = useTranslation("auth");

  let error = "";

  switch (errorCode) {
    case errorCodes.ERROR_USERNAME_NOT_AVAILABLE:
      error = t("Username taken");
      break;

    case errorCodes.ERROR_USERNAME_TOO_SHORT:
      error = t("Username too short");
      break;

    case errorCodes.ERROR_USERNAME_TOO_LONG:
      error = t("Username too long");
      break;

    case errorCodes.ERROR_GENERAL:
      error = authT("Something went wrong");
      break;

    case errorCodes.ERROR_EMAIL_NOT_VALID:
      error = t("Email not valid");
      break;

    case errorCodes.ERROR_EMAIL_NOT_AVAILABLE:
      error = authT("Email not available");
      break;

    case "ERROR_CURRENT_PASSWORD":
      error = authT("currentPasswordInvalid");
      break;
    case "ERROR_AUTH_RATE_LIMIT":
      error = authT("recoveryTryLater");
      break;
    case "ERROR_ACCOUNT_PASSWORD":
      error = authT("accountPasswordHint");
      break;

    case errorCodes.ERROR_PASSWORD_TOO_SHORT:
      error = t("Password too short");
      break;

    case errorCodes.ERROR_PASSWORD_TOO_LONG:
      error = t("Password too long");
      break;

    case errorCodes.ERROR_PASSWORDS_DO_NOT_MATCH:
      error = t("Password fields don't match");
      break;

    case errorCodes.ERROR_NO_COUNTRY:
      error = t("No country selected");
      break;

    default:
      return null;
  }

  return (
    <div id={id} className={styles.error}>
      {error}
    </div>
  );
}
